import SentMessages from "./SentMessages";
export default SentMessages;